import React from "react";
import PropTypes from "prop-types";
import { /* FormattedMessage,*/ FormattedNumber } from "react-intl";

// import messages from './messages';
import funDiamond from "./icon_pt_fun.png";
import importantDiamond from "./icon_pt_important.png";
import lastingDiamond from "./icon_pt_lasting.png";

const styles = {
  iconPoint: {
    margin: "0 0 3px 5px",
  },
};

class PointsLabelHeader extends React.PureComponent {
  // eslint-disable-line react/prefer-stateless-function

  render() {
    const { points, name, style, className } = this.props;
    let iconPoint = (
      <img style={styles.iconPoint} src={funDiamond} alt="Fun Icon" />
    );
    //  debugger;

    switch (name && name.toUpperCase()) {
      case "FUN":
        iconPoint = (
          <img style={styles.iconPoint} src={funDiamond} alt="Fun Icon" />
        );
        break;
      case "IMPORTANT":
        iconPoint = (
          <img
            style={styles.iconPoint}
            src={importantDiamond}
            alt="Important Icon"
          />
        );
        break;
      case "LASTING":
        iconPoint = (
          <img
            style={styles.iconPoint}
            src={lastingDiamond}
            alt="Lasting Icon"
          />
        );
        break;
      default:
        // iconPoint = <img style={styles.iconPoint} src={lastingDiamond} alt="Lasting Icon" />;
        break;
    }

    return (
      <span style={style} className={className}>
        <FormattedNumber value={points} />
        {iconPoint}
      </span>
    );
  }
}

PointsLabelHeader.propTypes = {
  name: PropTypes.string,
  points: PropTypes.number,
  style: PropTypes.object,
  className: PropTypes.string,
};

export default PointsLabelHeader;
